export const lightModeColors = {
  background: "#F1F5F9",
  componentBackground: "#FCFDFE",
  borderColor: "#E3E9EE",
  tabText: "#7C878E",
  sidebarText: "#393E44",
  primaryText: "#181B1F",
  secondaryText: "#7C878E",
  homeTabText: "#292D32",
  footerLine: "#E6E8EC",
  footerText: "#777E90",
};

export const darkModeColors = {
  background: "#181B1F",
  componentBackground: "#292D32",
  borderColor: "#393E44",
  tabText: "#7C878E",
  sidebarText: "#7C878E",
  primaryText: "#FFF",
  secondaryText: "#F1F5F9",
  homeTabText: "#FCFDFE",
  footerLine: "#FFF",
  footerText: "#FFF",
};
